import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import PaymentInfoTableWidget from '../../../widgets/payment/PaymentInfoTableWidget/PaymentInfoTableWidget';
import PaymentInfoTableFiltersWidget from '../../../widgets/payment/PaymentInfoTableFiltersWidget/PaymentInfoTableFiltersWidget';
import {
  useGetPaymentResourceCountQuery,
  useGetPaymentResourceQuery,
} from '../../../entities/payments/paymentResource/redux/paymentResource.api';
import prepareFilterParams from './utils';
import DEFAULT_PAYMENTS_FILTERS from '../../../widgets/payment/PaymentInfoTableFiltersWidget/constants';

function PaymentInfoPanel({ deletePaymentResourceParams }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [filters, setFilters] = useState(DEFAULT_PAYMENTS_FILTERS);

  const params = useMemo(() => prepareFilterParams(filters, rowsPerPage, page), [filters, rowsPerPage, page]);

  const { data: { data: payments = [] } = {}, isLoading, isFetching } = useGetPaymentResourceQuery({ params });

  const { data: countData } = useGetPaymentResourceCountQuery({ params });

  const handleChangePage = (_, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box>
      <PaymentInfoTableFiltersWidget filters={filters} setFilters={setFilters} setPage={setPage} />
      <PaymentInfoTableWidget
        payments={payments}
        deletePaymentResourceParams={deletePaymentResourceParams}
        count={countData?.data}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        loading={isLoading || isFetching}
      />
    </Box>
  );
}

PaymentInfoPanel.propTypes = {
  deletePaymentResourceParams: PropTypes.func,
};

PaymentInfoPanel.defaultProps = {
  deletePaymentResourceParams: null,
};

export default PaymentInfoPanel;
